import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import { UrlCollection } from "../../../common/url-collection";

interface NavItem {
    name: string;
    icon?: JSX.Element;
    path: string;
    subItems?: NavItem[]; // Mục con (submenu)
}

type Props = {
    isCollapsed: boolean;
    expandedSubMenu: string | null;
    currentPath: string;
    navItems: NavItem[];
    handleMenuClick: (item: NavItem) => void;
    toggleSubMenu: (name: string) => void;
}
const NavBar = ({isCollapsed, expandedSubMenu, currentPath, navItems, handleMenuClick, toggleSubMenu}: Props) => {
    return (
        <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item: NavItem) => (
            <div key={item.name}>
                {/* Link cha */}
                <div>
                    <button
                        onClick={() => {
                            handleMenuClick(item);
                            if (item.subItems) {
                                toggleSubMenu(item.name); // Toggle submenu nếu có
                            }
                        }}
                        className={`${isCollapsed ? "justify-center" : "justify-start"
                            } ${(currentPath.includes(item.path) || (item.path === UrlCollection.Dashboard && currentPath === '/')) ? "bg-gray-200" : ""} 
                            flex items-center gap-3 px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg w-full`}
                    >
                        {item.icon}
                        <span className={`${isCollapsed ? "hidden" : "block"}`}>
                            {item.name}
                        </span>
                        {item.subItems && (
                            <span className={`${isCollapsed ? "hidden" : "block"} ml-auto`}>
                                {expandedSubMenu === item.name ? (
                                    <ChevronUp size={18} />
                                ) : (
                                    <ChevronDown size={18} />
                                )}
                            </span>
                        )}
                    </button>
                </div>

                {/* Nếu có menu con, hiển thị submenu */}
                {item.subItems && !isCollapsed && (
                    <div
                        className={`tree-submenu ${expandedSubMenu === item.name ? "mt-1" : "h-0 overflow-hidden"
                            } transition-all duration-200 ease-in-out bg-gray-50 rounded-lg ml-2`}
                    >
                        {item.subItems.map((subItem) => (
                            <div
                                key={subItem.name}
                                onClick={() => {
                                    handleMenuClick(subItem);
                                }}
                                className={`${currentPath.includes(subItem.path) ? "bg-gray-200" : ""
                                    } cursor-pointer tree-item flex items-center gap-3 px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition`}
                            >
                                <span>{subItem.name}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        ))}
    </nav>

    )
}

export default NavBar
